import {
    OrderAddressInfo,
    OrderTypeEnum,
} from '../models/orders-type.model';

import { Invoice, Order } from '@api/order/order.models';

interface OrderDetailInfo {
    value?: Partial<Order>;
    subOrderSelected?: number;
    shippingAddress?: OrderAddressInfo;
    invoiceInfo?: Invoice;
    invoiceReturnInfo?: Invoice;
    showEcoTicket?: boolean;
    ecoTicketUrl?: string;

    invoiceUrl?: string;
    invoiceReturnUrl?: string;
}

export interface OrdersTypeState {
    orderType?: OrderTypeEnum;
    ordersStore?: Array<Partial<Order>>;
    ordersOnline?: Array<Partial<Order>>;
    nextIndex: number;
    hasMore: boolean;
    detailDisplayed: OrderDetailInfo;
}
/**
 * Estado inicial de la interface  "AppointmentState"
 */
export const ordersTypeInitialState: OrdersTypeState = {
    orderType: null,
    ordersStore: null,
    ordersOnline: null,
    nextIndex: 0,
    hasMore: false,
    detailDisplayed: {
        value: {
            egui: null,
            isEguiPrintAllowed: null,
        },
        shippingAddress: null,
        invoiceInfo: null,
        invoiceReturnInfo: null,
        showEcoTicket: null,
        ecoTicketUrl: null,

        invoiceUrl: null,
        invoiceReturnUrl: null,
    },
};
